import { useEffect, useState } from 'react';
let _sheetId = '';
let observers = [];
export const _setSheetId = (id) => {
    _sheetId = id;
    observers.forEach((update) => update(id));
};
export const useSheetId = () => {
    const [sheetId, setSheetId] = useState('');
    useEffect(() => {
        observers.push(setSheetId);
        setSheetId(_sheetId);
        return () => {
            observers = observers.filter((update) => update !== setSheetId);
            if (observers.length === 0) {
                _setSheetId('');
            }
        };
    }, []);
    return [sheetId, _setSheetId];
};
//# sourceMappingURL=useSheetId.js.map